<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
            
        </p>
        <p>
            {{ creditBureau.address_name }}
            <br />
            {{ address.street }}
            <br />
            {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
        </p>
        <br />
        <br /> Date: {{ date }}
        <p> To Whom It May Concern: </p>

        <P class="letter-content">
            Please remove all active fraud alerts on my credit file. This includes any temporary or extended fraud alerts.
            Along with this letter, I have included one document to verify my identity and one document to verify my address.
            Please reply to this letter and notify me in writing once these alerts have been removed.
        </P>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
